'use client';

import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useOverlay } from '@/components/hooks/useOverlay';
import Overlay from '@/components/ui/Overlay';
import LayoutOverlay from '@/components/ui/LayoutOverlay';
import Block from '@/components/ui/Block';
import OverlayTitle from '@/components/ui/LayoutOverlay/OverlayTitle';
import NonIdealState from '@/components/ui/NonIdealState';
import { OverlayKey } from '@/lib/enums/overlayKey.enum';
import useOfferOverlay from '@/lib/hooks/useOfferOverlay';

const OverlayAddDebtPaywall: React.FunctionComponent = () => {
  const { isOverlayOpen, zIndexOfOverlay, closeOverlay } = useOverlay(OverlayKey.lisa_volg_paywall);
  const { t } = useTranslation();
  const { open: openOfferForm } = useOfferOverlay();
  return (
    <Overlay
      isOpen={isOverlayOpen}
      onClose={closeOverlay}
      layout="default"
      zIndex={zIndexOfOverlay}
      hideClose={true}
    >
      <LayoutOverlay size="default">
        <Block
          width="narrow"
          theme="lighter"
        >
          <OverlayTitle onClose={closeOverlay} />
          <NonIdealState
            title={t('debtForm.debtDeny')}
            imageUrl="/img/denied.png"
            buttons={[
              {
                title: t('debtForm.activatePackage'),
                iconLeft: 'unlock',
                theme: 'primary',
                onClick: () => openOfferForm(),
              },
            ]}
          />
        </Block>
      </LayoutOverlay>
    </Overlay>
  );
};

OverlayAddDebtPaywall.displayName = 'OverlayAddDebtPaywall';

export default OverlayAddDebtPaywall;
